import Input from './input'

export const AmuiInput = Input

export default Vue => Vue.component(Input.name, Input)
